<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong style="color:black">Settings</strong>
      </div>
      <SettingsDialog :account="account" />
    </template>

    <div>
      Expand your Pro Network:  
      <span
        v-if="account.settings.expand_network" 
        class="ml-4 font-weight-bold green--text"
      >
        -ON-
      </span>
      <span v-else class="ml-4 font-weight-bold red--text">
        -OFF-
      </span>
    </div>
  </Section>
</template>

<script>
import { Section } from '@/components/pages'
import SettingsDialog from '../dialogs/Settings'

export default {
  name: 'AccountSettingsSection',

  components: { Section, SettingsDialog },

  props: ['account'],
}
</script>